import { PayloadAction } from '@reduxjs/toolkit';

import { CategoriesProgress } from '../../core/interfaces/ICategories';

export const CategoriesReducer = {
	setInitial: (
		state: CategoriesProgress,
		action: PayloadAction<CategoriesProgress>
	) => {
		state.categories = action.payload.categories;
		state.progressName = action.payload.progressName ?? '';
	},
};
